"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.years = exports.weekDays = exports.months = exports.largueMonths = exports.days = exports.customYears = exports.LIMIT_HOUR_TODAY_SATURDAY = exports.LIMIT_HOUR_TODAY_NATURAL_DAY = exports.LIMIT_HOUR_IN_SAME_DAY = void 0;
var days = exports.days = Array.from({
  length: 31
}, function (_, i) {
  return i + 1;
});
var months = exports.months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
var largueMonths = exports.largueMonths = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
var years = exports.years = Array.from({
  length: 12
}, function (_, i) {
  return new Date().getFullYear() + 1 - i;
});
var customYears = exports.customYears = function customYears(numberYears, initialYear) {
  return Array.from({
    length: numberYears
  }, function (_, i) {
    return initialYear + 1 - i;
  });
};
var weekDays = exports.weekDays = [{
  name: 'Domingo',
  "short": 'D',
  isWeekend: true
}, {
  name: 'Lunes',
  "short": 'L'
}, {
  name: 'Martes',
  "short": 'M'
}, {
  name: 'Miércoles',
  "short": 'M'
}, {
  name: 'Jueves',
  "short": 'J'
}, {
  name: 'Viernes',
  "short": 'V'
}, {
  name: 'Sábado',
  "short": 'S',
  isWeekend: true
}];
var LIMIT_HOUR_IN_SAME_DAY = exports.LIMIT_HOUR_IN_SAME_DAY = '13:00';
var LIMIT_HOUR_TODAY_NATURAL_DAY = exports.LIMIT_HOUR_TODAY_NATURAL_DAY = '20:00';
var LIMIT_HOUR_TODAY_SATURDAY = exports.LIMIT_HOUR_TODAY_SATURDAY = '13:30';